import { FlexContainer, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import useTranslation from 'Hooks/useTranslation';
import { lottiesPaths } from 'Constants/lottiesPaths';
import { TaxScreenType } from 'Types/common';
import { addDaysToDate } from '../utils';
import ResultInfo from '../ResultInfo';
import { useGetUserAutorizedDomiciliations } from '../DomiciliationBanner/hooks';
import * as Styled from './styles';

const MAXIMUM_DAYS_TO_ADD = 40;

const formatOrdinalNumber = (number: number): string => `${number}ª`;

const FiledReintents = ({ tax }: TaxScreenType): JSX.Element => {
  const { t } = useTranslation(locizeNS.DASHBOARD);
  const { data: userAutorizedDomiciliations } = useGetUserAutorizedDomiciliations();
  const { taxYear, filingInfo } = tax;

  const isGreaterThanOneFiling = filingInfo?.filedTimes && filingInfo?.filedTimes > 2;
  const isAutorizedDomiciliation = userAutorizedDomiciliations?.data?.some(
    domiciliation => domiciliation.item.isActive
  );
  return (
    <FlexContainer fullWidth fullHeight direction="column" gap="dimension_16">
      <Styled.Container
        fullWidth
        fullHeight
        justify="center"
        direction="column"
        align="center"
        gap="dimension_08"
      >
        <Text size="L_L_S" color="dark" type="headline">
          {taxYear}
        </Text>
        <Text type="paragraphs" size="L_L_M" color="dark" align="center">
          {t(`TaxScreen.filedReintents.title`, {
            context:
              (isAutorizedDomiciliation && 'isAutorizedDomiciliation') ||
              (isGreaterThanOneFiling && 'moreIntents'),
          })}
        </Text>
        <Styled.StyledLottie
          options={{
            path: lottiesPaths.MORE_INFO,
            rendererSetting: { progressiveLoad: true },
          }}
        />
        {filingInfo && <ResultInfo filingInfo={filingInfo} />}
        <Text type="paragraphs" color="dark" size="M_L_S" align="center">
          {t(`TaxScreen.filedReintents.info`, {
            context: isAutorizedDomiciliation && 'isAutorizedDomiciliation',
            intents: filingInfo?.filedTimes ? formatOrdinalNumber(filingInfo.filedTimes) : '',
          })}
        </Text>
        <Text type="paragraphs" color="dark" size="S_S_S" align="center">
          {t(`TaxScreen.filedReintents.subtitle`, {
            context: isAutorizedDomiciliation && 'isAutorizedDomiciliation',
            date: addDaysToDate(filingInfo?.recent?.filedAt, MAXIMUM_DAYS_TO_ADD),
          })}
        </Text>
      </Styled.Container>
    </FlexContainer>
  );
};

export default FiledReintents;
